import script from "./listMaterialCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./listMaterialCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./listMaterialCheckBox.vue?vue&type=style&index=0&id=473b14a6&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473b14a6"]])

export default __exports__